module.exports = __webpack_public_path__ + "static/img/document-seal.bb83c12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/package-service/document-seal.png
// module id = A/X+
// module chunks = 2